import React, { ReactNode } from "react";

interface IconRendererProps {
  icon?: ReactNode | string;
  size?: number; // optional size prop
}

const IconRenderer: React.FC<IconRendererProps> = ({ icon, size = 18 }) => {
  if (!icon) return null;

  // Case 1: string → render <img>
  if (typeof icon === "string") {
    return (
      <img
        src={icon}
        alt="menu icon"
        width={size}
        height={size}
        className={`w-[${size}px] h-[${size}px]`}
      />
    );
  }

  // Case 2: ReactNode → render directly
  return (
    <span
      style={{
        width: size,
        height: size,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {icon}
    </span>
  );
};

export default IconRenderer;
